module.exports = __webpack_public_path__ + "img/thumbnail_MalayanTapir_f_normal.84f5fe09.png";